import React from "react";

export const NavContext = React.createContext(null);
export const UserSettingsContext = React.createContext(null);
export const FooterContext = React.createContext(null);
export const ChatContext = React.createContext(null);
export const WindowContext = React.createContext(null);
export const RoomContext = React.createContext(null);
export const UserProfileCardContext = React.createContext(null);
